/**
 * **Do not import this directly!** This file may replace `index.ts` during build.
 *
 * @override index.ts
 */
export const environment = {
  production: true,
  server: {
    oauth: 'https://oauth.hipermercode.com/api',
    platform: 'https://kithoreca.hipermercode.com/api',
    qr: 'https://masterqr.hipermercode.eu/api',
    cp: 'https://cp.hipermercode.com/api',
  },
  API_KEY_MAPS: 'AIzaSyBjx52wGDFgPzKt-yQkbdHk-65f7APx7EQ',
  FACEBOOK_APP_ID: '695986997876526',
  GOOGLE_APP_ID:
    '593593863950-aq3vr00ceskv9uk205akl7op4nidqecg.apps.googleusercontent.com',
  PUBLIC_JWT:
    'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9' +
    '.eyJhdWQiOiJhYTViOTUyNDk5ZmE0Njk4OTE0YTg2OGIyNDllYWViOSIsImlzcyI6Imh0dHBzOi8vaGlwZXJtZXJjb2RlLmNvbSIsImV4cCI6MjMwOTAwMjY2Nn0' +
    '.4yO7Jzf5fEeVP8B2Z-XNxw_hHJ7d_ci96tgHDB4WtUc',
  firebase: {
    apiKey: 'AIzaSyAQyXtgu8m8Sr3kEtDhTJe8cxmiUedD7Uk',
    authDomain: 'kithoreca.firebaseapp.com',
    projectId: 'kithoreca',
    storageBucket: 'kithoreca.appspot.com',
    messagingSenderId: '297729036471',
    appId: '1:297729036471:web:3526c1ee84207b1bb5fd32',
    measurementId: 'G-FNL4366X15',
  },
  domain: 'https://kithoreca.hipermercode.com/',
  loginAfterRegister: true,
};
